/* Package JSON Import will be here */
import React, { useEffect, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "antd";
import { isEmpty } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
import Products from "containers/products/Products";
import Constants from "utilities/appConstants";
import NoData from "components/reusable/NoData";
import { getSchemeDetail } from "reducers/promotions";
import PromoDetails from "./PromoDetails";
/* Project Import will be here */

const PromoDetailsAndProducts = (props) => {
    const [isApiMethodCalled, setIsApiMethodCalled] = useState(false);

    const { promotions, translate } = useSelector((state) => ({
        promotions: props.pageType === Constants.PRODUCT_DETAILS 
            ? state.promotions.details 
            : state.promotions.list,
        translate: getTranslate(state.locale)
    }));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSchemeDetail({ schemeId: props.schemeId, needProducts: props.pageType !== Constants.PRODUCT_DETAILS, pageType: props.pageType }));
        setIsApiMethodCalled(true);
    }, []);

    const renderComponent = () => {
        const selectedPromo = promotions.selectedPromotionDetails;

        if (!isApiMethodCalled || promotions.isPromoDetailsLoading) {
            return (
                <div className="container pt-5">
                    <Spinner message={translate("promotion.loading.promotionDetail")} />
                </div>
            );
        }
        else if (isEmpty(selectedPromo)) {
            return (
                <div className="container mt-5">
                    <NoData NoDataMessage={translate("home.banner.noMappingBanner")} />
                </div>
            );
        }
        else {
            return (
                <Row className="promotion-list-scroll">
                    <Col span={24} xl={14} className="p-2">
                        <PromoDetails pageType={props.pageType} promoDetailsPageType={props.promoDetailsPageType} />
                    </Col>
                    {/* Product reducer is getting affected while showing scheme product from product details screen*/}
                    {props.pageType !== Constants.PRODUCT_DETAILS &&
                        < Col span={24} xl={10} className="promotion-details-p-container">
                            <Products pageType={Constants.SCHEME_DETAILS} />
                        </Col>
                    }
                </Row >
            );
        }
    };

    return (renderComponent());
};

export default PromoDetailsAndProducts;